import { getShellActions, loadApp } from '@nab/x-runtime';
import { retrieveJson } from '../../util/content-fragment';
import constants from '../../util/constants';
import { AppConfig } from '../../util/AppConfig';
import { debug } from '../../util/logger';

export const loadEmbeddedApp = async (config: AppConfig, rootElement: HTMLElement) => {
    let appConfigJson: any = {};
    // Retrieve the content fragment/forms JSON via API call
    if (config.appConfig) {
        appConfigJson = await retrieveJson(config.appConfig);
    }

    if (config.abandonFormNotification) {
        window.addEventListener(constants.EVENT_WINDOW_BEFORE_UNLOAD, (event) => {
            event.preventDefault();
            event.returnValue = false;
        });
    }

    // adding content fragment to appConfig
    if (config?.cf) {
        if (!appConfigJson.appConfig) {
            appConfigJson.appConfig = {};
        }
        appConfigJson.appConfig.cf = await retrieveJson(config.cf);
    }

    const urlParams = new URLSearchParams(window.location.search);
    const bagNumber = urlParams.get(constants.URL_PARAM_BAGNUMBER);
    if (bagNumber) {
        appConfigJson['appData'] = { ...appConfigJson['appData'], ... { bagNumber: bagNumber } };
    }

    const shellActions = getShellActions();

    let appLoaderConfig;

    // For app type XV2
    if (config.appType == constants.APP_TYPE_VERSION_2) {
        appLoaderConfig = {
            appMetaData: {
                id: config.tag,
                appType: config.appType,
                tag: config.tag,
                assetManifestUrl: config.manifest,
            },
            params: appConfigJson.params,
            appConfig: appConfigJson.appConfig,
            appData: appConfigJson.appData,
            hostElement: rootElement
        };
    } else {
        // For app type XV1
        appLoaderConfig = {
            appMetaData: {
                id: config.tag,
                appType: config.appType,
                tag: config.tag,
                assetManifestUrl: config.manifest,
                properties: appConfigJson
            },

            hostElement: rootElement
        };
    }

    try {
        debug(config, 'loading embed app, appLoaderConfig', appLoaderConfig);
        debug(config, 'appConfigJson', appConfigJson);
        await loadApp(appLoaderConfig);

        await shellActions.dispatchEvent(constants.APP_SHELL_LOADED_EVENT, {
            appLoaded: true,
            appName: config.tag
        });
    } catch (e) {
        debug(config, 'loading embed app error', e);
        await shellActions.dispatchEvent(constants.APP_SHELL_LOADED_EVENT, {
            appLoaded: false,
            appName: config.tag,
            errorMessage: e.message
        });
    }
};
